import dayjs from 'dayjs';
import PropTypes from 'prop-types';

//hooks
import useUser from '@/utils/hooks/swr/useUser';

//lib
import userDateFormat from '@/lib/user/dateFormat';

const CreatedAtCell = ({ value }) => {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const datesFormatted = dayjs(value).format(
        userDateFormat?.[user?.settings?.date_format] ?? 'YYYY-MM-DD'
    );
    return (
        <span className="leading-wide rounded-m bg-icoGray-100 px-3 py-2 text-xs text-icoGray-500 dark:bg-icoDarkMode-anthracite dark:text-icoDarkMode-wolf">
            {datesFormatted}
        </span>
    );
};

CreatedAtCell.propTypes = {
    value: PropTypes.string.isRequired
};

export default CreatedAtCell;
